import { render, staticRenderFns } from "./Topics.vue?vue&type=template&id=61424b4e&scoped=true&"
import script from "./Topics.vue?vue&type=script&lang=js&"
export * from "./Topics.vue?vue&type=script&lang=js&"
import style0 from "./Topics.vue?vue&type=style&index=0&id=61424b4e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61424b4e",
  null
  
)

export default component.exports